import type { ProfilePatch, ProfileSettings, UserProfile } from "@pack-it-up/core";
import type { DomainError, Result } from "@pack-it-up/shared";
import type { SettingsState } from "@pack-it-up/viewmodel";
import { useStoreValue } from "@pack-it-up/viewmodel/bindings";
import { useSession } from "./SessionProvider.js";

export interface MySettings {
  // `ready`: the settings have arrived from the stream (first emit).
  ready: boolean;
  profile: UserProfile | null;
  settings: ProfileSettings | null;
  save: (patch: ProfilePatch) => Promise<Result<void, DomainError>>;
}

// Reads the signed-in user's own profile + settings from the session `settingsStore`
// (`@pack-it-up/viewmodel`).
export const useMySettings = (): MySettings => {
  const { settings } = useSession();
  const value = useStoreValue<SettingsState, SettingsState>(settings, (s) => s);
  return {
    profile: value.profile,
    settings: value.settings,
    ready: value.ready,
    save: (patch) => settings.getState().save(patch),
  };
};
